<template>
  <div class="guia-codigos">
    <div ref="busca" class="guia-codigos__busca-container">
      <div class="guia-codigos__busca">
        <i class="icofont-search-1 guia-codigos__busca-icone"></i>

        <div class="guia-codigos__busca-campo">
          <span v-for="termo in buscas" :key="termo" class="guia-codigos__tag">
            {{ termo }}

            <button
              type="button"
              title="Remover filtro"
              @click="removerBusca(termo)"
            >
              <i class="icofont-close"></i>
            </button>
          </span>

          <input
            v-model.trim="buscaDigitada"
            type="text"
            placeholder="Pesquisar códigos..."
            autocomplete="off"
            @focus="aoFocarBusca"
            @input="aoDigitarBusca"
            @keyup.enter="adicionarBuscaDigitada"
          />
        </div>

        <button
          v-if="buscas.length || buscaDigitada"
          type="button"
          class="guia-codigos__limpar"
          title="Limpar pesquisa"
          @click="limparBusca"
        >
          <i class="icofont-close"></i>
        </button>
      </div>

      <div v-if="exibirSugestoes" class="guia-codigos__sugestoes">
        <div class="guia-codigos__sugestoes-titulo">Sugestões de busca</div>

        <ul>
          <li
            v-for="termo in sugestoes"
            :key="termo"
            @mousedown.prevent="selecionarSugestao(termo)"
          >
            <i class="icofont-search-1"></i>

            <span>{{ termo }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="temResultados" class="guia-codigos__grid">
      <!-- CID -->
      <div class="guia-codigos__card guia-codigos__card--cid">
        <div class="guia-codigos__card-header">
          <h2>
            <i class="icofont-book-alt"></i>
            CID-10
          </h2>

          <span class="guia-codigos__contador">
            {{ resultadosCid.length }}
          </span>
        </div>

        <div class="guia-codigos__lista">
          <div
            v-for="item in cidVisiveis"
            :key="getItemKey(item)"
            class="guia-codigos__item"
          >
            <div class="guia-codigos__item-conteudo">
              <div class="guia-codigos__codigo">
                <span>{{ item.code }}</span>

                <span v-if="item.id_grupo" class="guia-codigos__grupo">
                  {{ item.id_grupo }}
                </span>

                <span v-if="item.nm === 1" class="guia-codigos__nm"> NM </span>
              </div>

              <div class="guia-codigos__descricao">
                {{ item.name }}
              </div>
            </div>

            <button
              type="button"
              class="guia-codigos__copiar"
              title="Copiar código"
              @click="copiarCodigo(item.code)"
            >
              <i
                :class="
                  codigoCopiado === item.code
                    ? 'icofont-check guia-codigos__copiado'
                    : 'icofont-copy'
                "
              ></i>
            </button>
          </div>
        </div>

        <button
          v-if="podeVerMaisCid"
          type="button"
          class="guia-codigos__ver-mais"
          @click="verMais('cid')"
        >
          Ver mais

          <span>
            {{ quantidadeRestante('cid') }}
          </span>
        </button>
      </div>

      <!-- CIAP -->
      <div class="guia-codigos__card guia-codigos__card--ciap">
        <div class="guia-codigos__card-header">
          <h2>
            <i class="icofont-notebook"></i>
            CIAP-2
          </h2>

          <span class="guia-codigos__contador">
            {{ resultadosCiap.length }}
          </span>
        </div>

        <div class="guia-codigos__lista">
          <div
            v-for="item in ciapVisiveis"
            :key="getItemKey(item)"
            class="guia-codigos__item"
          >
            <div class="guia-codigos__item-conteudo">
              <div class="guia-codigos__codigo">
                <span>{{ item.code }}</span>

                <span v-if="item.id_grupo" class="guia-codigos__grupo">
                  {{ item.id_grupo }}
                </span>

                <span v-if="item.nm === 1" class="guia-codigos__nm"> NM </span>
              </div>

              <div class="guia-codigos__descricao">
                {{ item.name }}
              </div>
            </div>

            <button
              type="button"
              class="guia-codigos__copiar"
              title="Copiar código"
              @click="copiarCodigo(item.code)"
            >
              <i
                :class="
                  codigoCopiado === item.code
                    ? 'icofont-check guia-codigos__copiado'
                    : 'icofont-copy'
                "
              ></i>
            </button>
          </div>
        </div>

        <button
          v-if="podeVerMaisCiap"
          type="button"
          class="guia-codigos__ver-mais"
          @click="verMais('ciap')"
        >
          Ver mais

          <span>
            {{ quantidadeRestante('ciap') }}
          </span>
        </button>
      </div>

      <!-- SIGTAP -->
      <div class="guia-codigos__card guia-codigos__card--sigtap">
        <div class="guia-codigos__card-header">
          <h2>
            <i class="icofont-stethoscope"></i>
            SIGTAP
          </h2>

          <span class="guia-codigos__contador">
            {{ resultadosSigtap.length }}
          </span>
        </div>

        <div class="guia-codigos__lista">
          <div
            v-for="item in sigtapVisiveis"
            :key="getItemKey(item)"
            class="guia-codigos__item"
          >
            <div class="guia-codigos__item-conteudo">
              <div class="guia-codigos__codigo">
                <span>{{ item.code }}</span>

                <span v-if="item.id_grupo" class="guia-codigos__grupo">
                  {{ item.id_grupo }}
                </span>

                <span v-if="item.nm === 1" class="guia-codigos__nm"> NM </span>
              </div>

              <div class="guia-codigos__descricao">
                {{ item.name }}
              </div>
            </div>

            <button
              type="button"
              class="guia-codigos__copiar"
              title="Copiar código"
              @click="copiarCodigo(item.code)"
            >
              <i
                :class="
                  codigoCopiado === item.code
                    ? 'icofont-check guia-codigos__copiado'
                    : 'icofont-copy'
                "
              ></i>
            </button>
          </div>
        </div>

        <button
          v-if="podeVerMaisSigtap"
          type="button"
          class="guia-codigos__ver-mais"
          @click="verMais('sigtap')"
        >
          Ver mais

          <span>
            {{ quantidadeRestante('sigtap') }}
          </span>
        </button>
      </div>
    </div>

    <div v-else class="guia-codigos__vazio">
      <i class="icofont-folder-open"></i>

      <h3>Nenhum resultado encontrado</h3>

      <p>Tente buscar por outro código ou termo.</p>
    </div>

    <transition name="toast">
      <div
        v-if="toast.visivel"
        class="guia-codigos__toast"
        :class="{
          'guia-codigos__toast--erro': toast.erro,
        }"
      >
        <i
          :class="
            toast.erro ? 'icofont-exclamation-circle' : 'icofont-check-circle'
          "
        ></i>

        {{ toast.mensagem }}
      </div>
    </transition>
  </div>
</template>

<script>
import { rawCid } from './data/rawCid'
import { rawCiap } from './data/rawCiap'
import { rawSigtap } from './data/rawSigtap'

export default {
  name: 'GuiaCodigosIndicadores',
  data() {
    return {
      buscas: [],
      buscaDigitada: '',
      mostrarSugestoes: false,
      codigoCopiado: null,
      limiteInicial: 10,
      quantidadePorPagina: 10,
      limites: {
        cid: 10,
        ciap: 10,
        sigtap: 10,
      },
      toast: {
        visivel: false,
        mensagem: '',
        erro: false,
      },
      toastTimer: null,
      sugestoes: [
        'ABORTO',
        'ACONSELHAMENTO',
        'ANTICONCEPCIONAL',
        'CARIOSTÁTICO',
        'CITOPATOLÓGICO',
        'COMPLICAÇÕES',
        'CONTRACEPÇÃO',
        'DIABETES',
        'ENDOMETRIOSE',
        'EXAME',
        'EXODONTIA',
        'FLÚOR',
        'GESTAÇÃO',
        'GRAVIDEZ',
        'HEMOGLOBINA',
        'HEMORRAGIA',
        'HEPATITE',
        'HIPERTENSÃO',
        'HIV',
        'MAMA',
        'MAMOGRAFIA',
        'MEDO',
        'MENSTRUAÇÃO',
        'ORIENTAÇÃO',
        'OUTROS',
        'PARTO',
        'PÉ',
        'PROFILAXIA',
        'PUERPERAL',
        'PUERPÉRIO',
        'RASPAGEM',
        'RESTAURAÇÃO',
        'SELANTE',
        'SEXUAL',
        'SÍFILIS',
        'SINTOMAS',
        'TESTE RÁPIDO',
        'TRA/ART',
        'ÚTERO',
      ],
    }
  },

  computed: {
    /**
     * Une os códigos CID, CIAP e SIGTAP em uma estrutura única.
     *
     * @returns {Array}
     */
    codigos() {
      return [
        ...rawSigtap.map((item) => ({
          type: 'SIGTAP',
          code: item.codigo,
          name: item.nome || 'Sem descrição',
          id_grupo: item.id_grupo,
          nm: item.nm,
        })),

        ...rawCiap.map((item) => ({
          type: 'CIAP-2',
          code: item.codigo,
          name: item.nome || 'Sem descrição',
          id_grupo: item.id_grupo,
          nm: item.nm,
        })),

        ...rawCid.map((item) => ({
          type: 'CID-10',
          code: item.codigo,
          name: item.nome || 'Sem descrição',
          id_grupo: item.id_grupo,
          nm: item.nm,
        })),
      ]
    },

    /**
     * Filtra e ordena todos os códigos conforme os termos selecionados.
     *
     * @returns {Array}
     */
    resultados() {
      const buscas = this.buscas
        .map((termo) => this.normalizarTexto(termo))
        .filter(Boolean)

      const buscaDigitada = this.normalizarTexto(this.buscaDigitada)

      if (buscaDigitada) {
        buscas.push(buscaDigitada)
      }

      const codigos =
        buscas.length === 0
          ? this.codigos
          : this.codigos.filter((item) => {
              const texto = this.normalizarTexto(
                [item.code, item.name, item.id_grupo].filter(Boolean).join(' ')
              )

              return buscas.some((busca) => texto.includes(busca))
            })

      return [...codigos].sort((a, b) => {
        const grupoA = String(a.id_grupo || '')
        const grupoB = String(b.id_grupo || '')

        const comparacaoGrupo = grupoA.localeCompare(grupoB, 'pt-BR')

        if (comparacaoGrupo !== 0) {
          return comparacaoGrupo
        }

        const nmA = a.nm === 1 ? 0 : 1
        const nmB = b.nm === 1 ? 0 : 1

        if (nmA !== nmB) {
          return nmA - nmB
        }

        return a.name.localeCompare(b.name, 'pt-BR')
      })
    },

    /**
     * Retorna somente os resultados CID.
     *
     * @returns {Array}
     */
    resultadosCid() {
      return this.resultados.filter((item) => item.type === 'CID-10')
    },

    /**
     * Retorna somente os resultados CIAP.
     *
     * @returns {Array}
     */
    resultadosCiap() {
      return this.resultados.filter((item) => item.type === 'CIAP-2')
    },

    /**
     * Retorna somente os resultados SIGTAP.
     *
     * @returns {Array}
     */
    resultadosSigtap() {
      return this.resultados.filter((item) => item.type === 'SIGTAP')
    },

    /**
     * Retorna os CID atualmente visíveis.
     *
     * @returns {Array}
     */
    cidVisiveis() {
      return this.resultadosCid.slice(0, this.limites.cid)
    },

    /**
     * Retorna os CIAP atualmente visíveis.
     *
     * @returns {Array}
     */
    ciapVisiveis() {
      return this.resultadosCiap.slice(0, this.limites.ciap)
    },

    /**
     * Retorna os SIGTAP atualmente visíveis.
     *
     * @returns {Array}
     */
    sigtapVisiveis() {
      return this.resultadosSigtap.slice(0, this.limites.sigtap)
    },

    podeVerMaisCid() {
      return this.cidVisiveis.length < this.resultadosCid.length
    },

    podeVerMaisCiap() {
      return this.ciapVisiveis.length < this.resultadosCiap.length
    },

    podeVerMaisSigtap() {
      return this.sigtapVisiveis.length < this.resultadosSigtap.length
    },

    /**
     * Informa se existe ao menos um resultado.
     *
     * @returns {boolean}
     */
    temResultados() {
      return this.resultados.length > 0
    },

    /**
     * Controla a exibição das sugestões.
     *
     * @returns {boolean}
     */
    exibirSugestoes() {
      return this.mostrarSugestoes && this.sugestoes.length > 0
    },
  },
  watch: {
    buscas: {
      handler() {
        this.resetarLimites()
      },
      deep: true,
    },

    buscaDigitada() {
      this.resetarLimites()
    },
  },
  mounted() {
    this.aplicarBuscaQuery()

    document.addEventListener('click', this.fecharSugestoesAoClicarFora)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.fecharSugestoesAoClicarFora)

    clearTimeout(this.toastTimer)
  },
  methods: {
    /**
     * Aplica os termos de busca recebidos pela query string.
     *
     * @returns {void}
     */
    aplicarBuscaQuery() {
      const busca = this.$route.query.busca

      if (!busca) {
        return
      }

      this.buscas = (Array.isArray(busca) ? busca : [busca])
        .map((termo) => String(termo).trim())
        .filter(Boolean)

      this.mostrarSugestoes = false
    },

    /**
     * Exibe as sugestões ao focar no campo quando a busca estiver vazia.
     */
    aoFocarBusca() {
      this.mostrarSugestoes = !this.buscaDigitada
    },

    /**
     * Controla a exibição das sugestões conforme o valor da busca.
     */
    aoDigitarBusca() {
      this.mostrarSugestoes = !this.buscaDigitada
    },

    /**
     * Remove acentos e converte o texto para minúsculo.
     *
     * @param {string} texto
     * @returns {string}
     */
    normalizarTexto(texto) {
      if (!texto) {
        return ''
      }

      return String(texto)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },

    /**
     * Retorna uma chave única para utilização no v-for.
     *
     * @param {Object} item
     * @returns {string}
     */
    getItemKey(item) {
      return `${item.type}-${item.code}-${item.id_grupo || ''}`
    },

    /**
     * Adiciona uma sugestão aos termos de pesquisa.
     *
     * @param {string} termo
     * @returns {void}
     */
    selecionarSugestao(termo) {
      if (!this.buscas.includes(termo)) {
        this.buscas.push(termo)
      }

      this.buscaDigitada = ''
      this.mostrarSugestoes = false
    },

    /**
     * Remove um termo da pesquisa.
     *
     * @param {string} termo
     * @returns {void}
     */
    removerBusca(termo) {
      this.buscas = this.buscas.filter((item) => item !== termo)
    },

    /**
     * Adiciona o texto digitado aos termos de pesquisa.
     *
     * @returns {void}
     */
    adicionarBuscaDigitada() {
      const termo = this.buscaDigitada.trim()

      if (!termo) {
        return
      }

      if (!this.buscas.includes(termo)) {
        this.buscas.push(termo)
      }

      this.buscaDigitada = ''
      this.mostrarSugestoes = false
    },

    /**
     * Limpa o texto pesquisado.
     */
    limparBusca() {
      this.buscas = []
      this.buscaDigitada = ''
      this.mostrarSugestoes = true

      this.$nextTick(() => {
        const input = this.$el.querySelector('.guia-codigos__busca input')

        if (input) {
          input.focus()
        }
      })
    },

    /**
     * Fecha as sugestões quando o usuário clicar fora da busca.
     *
     * @param {MouseEvent} event
     */
    fecharSugestoesAoClicarFora(event) {
      if (this.$refs.busca && !this.$refs.busca.contains(event.target)) {
        this.mostrarSugestoes = false
      }
    },

    /**
     * Adiciona mais resultados à categoria selecionada.
     *
     * @param {'cid'|'ciap'|'sigtap'} tipo
     */
    verMais(tipo) {
      this.limites[tipo] += this.quantidadePorPagina
    },

    /**
     * Retorna a quantidade de registros que ainda não foram exibidos.
     *
     * @param {'cid'|'ciap'|'sigtap'} tipo
     * @returns {number}
     */
    quantidadeRestante(tipo) {
      const totais = {
        cid: this.resultadosCid.length,
        ciap: this.resultadosCiap.length,
        sigtap: this.resultadosSigtap.length,
      }

      return Math.max(totais[tipo] - this.limites[tipo], 0)
    },

    /**
     * Restaura a quantidade inicial de itens exibidos.
     */
    resetarLimites() {
      this.limites = {
        cid: this.limiteInicial,
        ciap: this.limiteInicial,
        sigtap: this.limiteInicial,
      }
    },

    /**
     * Copia o código selecionado para a área de transferência.
     *
     * @param {string} codigo
     */
    async copiarCodigo(codigo) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(codigo)
        } else {
          this.copiarCodigoFallback(codigo)
        }

        this.codigoCopiado = codigo

        this.exibirToast(`Código ${codigo} copiado!`)

        setTimeout(() => {
          if (this.codigoCopiado === codigo) {
            this.codigoCopiado = null
          }
        }, 2000)
      } catch (error) {
        try {
          this.copiarCodigoFallback(codigo)

          this.codigoCopiado = codigo

          this.exibirToast(`Código ${codigo} copiado!`)
        } catch (fallbackError) {
          this.exibirToast('Erro ao copiar o código.', true)
        }
      }
    },

    /**
     * Faz a cópia utilizando execCommand para navegadores ou
     * contextos onde a Clipboard API não está disponível.
     *
     * @param {string} codigo
     */
    copiarCodigoFallback(codigo) {
      const textarea = document.createElement('textarea')

      textarea.value = codigo
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '0'

      document.body.appendChild(textarea)

      textarea.focus()
      textarea.select()

      const copiado = document.execCommand('copy')

      document.body.removeChild(textarea)

      if (!copiado) {
        throw new Error('Não foi possível copiar o código.')
      }
    },

    /**
     * Exibe uma mensagem temporária na tela.
     *
     * @param {string} mensagem
     * @param {boolean} erro
     */
    exibirToast(mensagem, erro = false) {
      clearTimeout(this.toastTimer)

      this.toast = {
        visivel: true,
        mensagem,
        erro,
      }

      this.toastTimer = setTimeout(() => {
        this.toast.visivel = false
      }, 2500)
    },
  },
}
</script>

<style lang="scss" scoped>
.guia-codigos {
  width: 100%;
  min-height: 100%;
  padding: 24px;
  background: #f3f4f6;
  color: #1f2937;

  &__busca-container {
    position: relative;
    z-index: 20;
    max-width: 1280px;
    margin: 0 auto 24px;
  }

  &__busca {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__busca-campo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-height: 54px;
    padding: 8px 48px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
    transition: 0.2s;

    &:focus-within {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
    }

    input {
      flex: 1;
      min-width: 180px;
      padding: 7px 0;
      color: #111827;
      font-size: 16px;
      background: transparent;
      border: 0;
      outline: none;
      box-shadow: none;

      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  &__tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
    padding: 5px 8px 5px 10px;
    color: #1d4ed8;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 999px;

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      padding: 0;
      color: #60a5fa;
      background: transparent;
      border: 0;
      border-radius: 50%;
      cursor: pointer;

      &:hover {
        color: #1d4ed8;
        background: #dbeafe;
      }

      i {
        font-size: 11px;
      }
    }
  }

  &__busca-icone {
    position: absolute;
    left: 17px;
    z-index: 1;
    color: #9ca3af;
  }

  &__limpar {
    position: absolute;
    right: 16px;
    padding: 4px;
    border: none;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;

    &:hover {
      color: #4b5563;
    }
  }

  &__sugestoes {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    overflow: hidden;
    border: 1px solid #f3f4f6;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);

    ul {
      max-height: 280px;
      margin: 0;
      padding: 0;
      overflow-y: auto;
      list-style: none;
    }

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 11px 16px;
      border-bottom: 1px solid #f9fafb;
      color: #374151;
      font-size: 16px;
      cursor: pointer;
      transition: 0.15s;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: #eff6ff;
      }

      i {
        color: #d1d5db;
        font-size: 16px;
      }
    }
  }

  &__sugestoes-titulo {
    padding: 10px 16px;
    border-bottom: 1px solid #f3f4f6;
    background: #f9fafb;
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
    gap: 24px;
    max-width: 1280px;
    margin: 0 auto;
  }

  &__card {
    overflow: hidden;
    border: 1px solid #f3f4f6;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);

    &--cid {
      .guia-codigos {
        &__card-header {
          border-color: #e0e7ff;
          background: #eef2ff;
          color: #3730a3;
        }

        &__contador {
          background: #c7d2fe;
        }
      }
    }

    &--ciap {
      .guia-codigos {
        &__card-header {
          border-color: #d1fae5;
          background: #ecfdf5;
          color: #065f46;
        }

        &__contador {
          background: #a7f3d0;
        }
      }
    }

    &--sigtap {
      .guia-codigos {
        &__card-header {
          border-color: #fef3c7;
          background: #fffbeb;
          color: #92400e;
        }

        &__contador {
          background: #fde68a;
        }
      }
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 16px;
    border-bottom: 1px solid;

    h2 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 18px;
      font-weight: 600;

      i {
        font-size: 20px;
      }
    }
  }

  &__contador {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 72px;
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    transition: background 0.15s;

    &:hover {
      background: #f9fafb;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &__item-conteudo {
    flex: 1;
    min-width: 0;
    padding-right: 12px;
  }

  &__codigo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    color: #111827;
    font-size: 14px;
    font-weight: 700;
  }

  &__descricao {
    color: #4b5563;
    font-size: 12px;
    line-height: 1.4;
  }

  &__grupo,
  &__nm {
    padding: 2px 6px;
    border-radius: 5px;
    font-size: 10px;
    line-height: 1.3;
    text-transform: uppercase;
  }

  &__grupo {
    background: #e5e7eb;
    color: #374151;
    font-weight: 500;
  }

  &__nm {
    background: #dbeafe;
    color: #1d4ed8;
    font-weight: 700;
  }

  &__copiar {
    flex-shrink: 0;
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;
    transition: 0.15s;

    i {
      font-size: 16px;
    }

    &:hover {
      background: #eff6ff;
      color: #2563eb;
    }
  }

  &__copiado {
    color: #22c55e;
  }

  &__ver-mais {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    width: 100%;
    padding: 12px 16px;
    border: none;
    border-top: 1px solid #f3f4f6;
    background: #ffffff;
    color: #4b5563;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.15s;

    &:hover {
      background: #f9fafb;
      color: #2563eb;
    }

    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      height: 20px;
      padding: 0 6px;
      border-radius: 999px;
      background: #f3f4f6;
      color: #6b7280;
      font-size: 10px;
    }
  }

  &__vazio {
    padding: 48px 20px;
    text-align: center;

    > i {
      margin-bottom: 12px;
      color: #d1d5db;
      font-size: 40px;
    }

    h3 {
      margin: 0 0 5px;
      color: #111827;
      font-size: 18px;
    }

    p {
      margin: 0;
      color: #6b7280;
      font-size: 14px;
    }
  }

  &__toast {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #1f2937;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);

    i {
      color: #4ade80;
      font-size: 17px;
    }

    &--erro {
      background: #dc2626;

      i {
        color: #ffffff;
      }
    }
  }
}

.toast {
  &-enter-active,
  &-leave-active {
    transition: 0.25s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(15px);
  }
}

@media (max-width: 991px) {
  .guia-codigos {
    &__grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    &__card {
      &--sigtap {
        grid-column: span 2;
      }
    }
  }
}

@media (max-width: 767px) {
  .guia-codigos {
    padding: 16px;

    &__grid {
      grid-template-columns: 1fr;
    }

    &__card {
      &--sigtap {
        grid-column: auto;
      }
    }

    &__busca {
      input {
        padding-top: 13px;
        padding-bottom: 13px;
        font-size: 14px;
      }
    }
  }
}
</style>
